import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Descriptions, Flex, Row, Space, Statistic, Table } from 'antd';
import CollaboratorService from 'services/collaborator';
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import { useAuth } from "contexts/auth"
import { useApp } from "contexts/app"
import { useWorkSpace } from 'contexts/workspace';

const service = new CollaboratorService();

const Dashboard = () => {
  const [collaborator, setCollaborator] = useState({ order_list: [] })
  const { workspace } = useWorkSpace();
  const websiteUrl = String(workspace?.websiteUrl || '').replace(/\/$/, '');
  
   const { showNotify, modal, showLoading, prompt } = useApp();


  const { user, logout } = useAuth()

  useEffect(() => {
    loadData();
  }, [])

  const loadData = async () => {
    const cl = await service.statistic();
    setCollaborator(cl)
  }

  const copyShareLink = async () => {
    await window.navigator.clipboard.writeText(`${websiteUrl}?ref=${user.id}`)
    showNotify("Đã copy link tiếp thị liên kết")

  }


  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Card>
          <Row gutter={[16, 16]}>
            <Col span={18}>
              <Statistic title="Số Dư Hoa hồng" value={collaborator.commission} />

            </Col>
            <Col span={6}>
              <Space direction='vertical'>
                <Button type='primary'>Yêu cầu rút tiền</Button>
                <Descriptions size='small'>
                  <Descriptions.Item label="Link tiếp thị">
                    <Button type='link' size='small' onClick={copyShareLink}>Copy</Button>
                  </Descriptions.Item>

                </Descriptions>
              </Space>

            </Col>
          </Row>

        </Card>

      </Col>
      <Col span={24}>
        <Flex justify='flex-end'>7 ngày qua</Flex>
      </Col>
      <Col span={8}>
        <Card>
          <Statistic title="Đơn hàng" value={collaborator.orders} />


        </Card>

      </Col>
      <Col span={8}>
        <Card>
          <Statistic title="Hoa hồng ước tính" value={collaborator.commission_all} precision={0} />
        </Card>

      </Col>

      <Col span={24}>
        <Card size='small'>
          <Table columns={[
            {
              title: 'Đơn hàng',

              render: (record) => (
                <Space direction='vertical'>
                  <a>{record.id}</a>
                  {formatDate(record.create_on)}
                </Space>
              ),
            },

            {
              title: 'Khách hàng',

              render: (record) => (
                <Space direction='vertical'>
                  {record.customer.full_name}

                </Space>
              ),
            },

            {
              title: 'Hoa hồng',

              render: (record) => (
                <Space direction='vertical'>
                  <a>{formatCurrency(record.commission)}</a>

                </Space>
              ),
            },
          ]} dataSource={collaborator.order_list} />
        </Card>
      </Col>

    </Row>
  )
}

export default Dashboard;